import GameStatesEnum from '../GameStatesEnum'
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class BigWinState extends BaseState {

  begin() {
    //Signals.showBigWinComplete.addOnce(this.end, this)
    Signals.showBigWin.dispatch(this.model.bigWin)
    this.end()
  }

  end = () => {
    this.gameState = GameStatesEnum.START_COUNTUP_WINNINGS
    this.stateMachine.setState(this.gameState)
  }

  cleanUp() {
    Signals.showBigWinComplete.remove(this.end, this)
  }

}
